<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="true">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">

                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data Found</strong></div>
                </template>

                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(addedby)="data">
                  {{ data.item.addedby.username }}
                </template>

                <template #cell(period)="data">
                  <span @click="edit(data.item.id, data.item.month, data.item.year, data.item.status)" style="cursor: pointer;"
                    @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                    <span
                      :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                        data.item.month }} - {{ data.item.year }}</span>
                  </span>
                </template>

                <template #cell(status)="data">
                  <small v-if="data.item.status == 1" class="badge bg-secondary text-white">Pending</small>
                  <small v-if="data.item.status == 2" class="badge bg-info text-white">Approved</small>
                </template>

                <template #cell(actions)="data">
                  <b-button v-if="data.item.status == 1" size="sm"
                    @click="approve(data.item.id, data.item.month, data.item.year)" variant="info">
                    <i class="mdi mdi-check"></i>
                  </b-button>
                  <router-link v-else
                    :to="{ path: '/print-checkoff', query: { id: data.item.id, month: data.item.month, year: data.item.year } }"
                    type="button" class="btn-sm btn-dark" title="Print"> <i class="mdi mdi-printer"></i></router-link>
                  <b-button :disabled="data.item.status == 2" size="sm"
                    @click="edit(data.item.id, data.item.month, data.item.year, data.item.status)" variant="primary">
                    <i class="mdi mdi-clipboard-text"></i>
                  </b-button>
                  <b-button :disabled="data.item.status == 2" size="sm"
                    @click="deleteModal(data.item.id, data.item.month, data.item.year)" variant="danger">
                    <i class="mdi mdi-trash-can"></i>
                  </b-button>
                </template>

              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Recorded Expenses</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="check-list-items" centered size="xl" hide-header hide-footer no-close-on-backdrop>
      <h4 class="border-bottom border-2 border-secondary modal-title mb-4 mt-2">Checkoff List | {{ name }}</h4>
      <div style="max-height: 450px; overflow-y: auto;">
        <table class="table table-striped" style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr class="align-middle">
              <th class="p-0 text-center">
                <span v-if="show_member" v-click-outside="() => { show_member = false; new_member = ''; }"
                  class="mb-1 rounded shadow shadow-lg p-1 bg-white"
                  style="position: absolute; z-index: 10; transform: translateY(-100%); width:300px;">
                  <v-select :options="members" placeholder="Select an Option" v-model="new_member" label="name"
                    :reduce="member => member.member_id" @input="addNewItem"></v-select>
                </span>
                <span v-if="status != 2">
                  <i v-if="!show_member" @click="show_member = true"
                    class="fs-2 btn text-primary mdi mdi-plus-circle"></i>
                  <i v-else @click="show_member = false" class="fs-2 btn text-primary mdi mdi-close-circle"></i>
                </span>
              </th>
              <th>Member</th>
              <th>Saving</th>
              <th>Loan</th>
              <th>COFU</th>
              <th>Subscription</th>
              <th>Total</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody v-if="checkoff_list_loader">
            <tr>
              <td colspan="7" class="text-center">
                <b-spinner small></b-spinner>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr v-for="(item, index) in checkoff_list_items" :key="index" class="align-middle">
              <td class="text-center">{{ index + 1 }}</td>
              <td>

                <span>
                  <span>{{ item.member.name }}</span>
                  <span class="d-block text-info fw-bold">{{ item.member.member_id }}</span>
                </span>
              </td>
              <td>
                <span v-if="(cell_index == 1) && (item_index == index)"
                  class="mb-1 rounded shadow p-1 bg-dark text-white"
                  style="position: absolute; z-index: 10; transform: translateY(-100%);">
                  {{ commas(item.saving) }}
                </span>
                <input @change.prevent="item.changed = true" @focus="item_index = index; cell_index = 1;"
                  @blur="cell_index = 0" :class="{ 'border-0': item_index != index }" v-model.number="item.saving"
                  :style="{ width: (item.saving != 0 ? (item.saving.toString().length + 4) : 5) + 'ch', backgroundColor: 'transparent' }"
                  class="form-control" :readonly="status == 2" />
              </td>

              <td>
                <span v-if="(cell_index == 2) && (item_index == index)"
                  class="mb-1 rounded shadow p-1 bg-dark text-white"
                  style="position: absolute; z-index: 10; transform: translateY(-100%);">
                  {{ commas(item.loan) }}
                </span>
                <input @change.prevent="item.changed = true" @focus="item_index = index; cell_index = 2;"
                  @blur="cell_index = 0" :class="{ 'border-0': item_index != index }" v-model.number="item.loan"
                  :style="{ width: (item.loan != 0 ? (item.loan.toString().length + 4) : 5) + 'ch', backgroundColor: 'transparent' }"
                  class="form-control" :readonly="status == 2" />
              </td>

              <td>
                <span v-if="(cell_index == 3) && (item_index == index)"
                  class="mb-1 rounded shadow p-1 bg-dark text-white"
                  style="position: absolute; z-index: 10; transform: translateY(-100%);">
                  {{ commas(item.cofu) }}
                </span>
                <input @change.prevent="item.changed = true" @focus="item_index = index; cell_index = 3;"
                  @blur="cell_index = 0" :class="{ 'border-0': item_index != index }" v-model.number="item.cofu"
                  :style="{ width: (item.cofu != 0 ? (item.cofu.toString().length + 4) : 5) + 'ch', backgroundColor: 'transparent' }"
                  class="form-control" :readonly="status == 2" />
              </td>

              <td>
                <span v-if="(cell_index == 4) && (item_index == index)"
                  class="mb-1 rounded shadow p-1 bg-dark text-white"
                  style="position: absolute; z-index: 10; transform: translateY(-100%);">
                  {{ commas(item.subscription) }}
                </span>
                <input @change.prevent="item.changed = true" @focus="item_index = index; cell_index = 4;"
                  @blur="cell_index = 0" :class="{ 'border-0': item_index != index }" v-model.number="item.subscription"
                  :style="{ width: (item.subscription != 0 ? (item.subscription.toString().length + 4) : 5) + 'ch', backgroundColor: 'transparent' }"
                  class="form-control" :readonly="status == 2" />
              </td>

              <td class="fw-bold">{{ commas((item.saving + item.loan + item.cofu + item.subscription) || '-') }}</td>

              <td>
                <button @click.prevent="remove(item.id, item.member)" class="btn btn-danger btn-sm"
                  :disabled="status == 2"><i class="mdi mdi-trash-can"></i></button>
              </td>
            </tr>
          </tbody>
          <tfoot style="position: sticky; bottom: 0; background-color: white; z-index: 1;">
            <tr class="fw-bold">
              <td></td>
              <td>Total</td>
              <td>{{commas(checkoff_list_items.reduce((total, item) => total + (item.saving || 0), 0))}}</td>
              <td>{{commas(checkoff_list_items.reduce((total, item) => total + (item.loan || 0), 0))}}</td>
              <td>{{commas(checkoff_list_items.reduce((total, item) => total + (item.cofu || 0), 0))}}</td>
              <td>{{commas(checkoff_list_items.reduce((total, item) => total + (item.subscription || 0), 0))}}</td>
              <td class="fs-5 text-primary fw-bold">{{commas(checkoff_list_items.reduce((total, item) => total +
                (item.saving
                  + item.loan + item.cofu + item.subscription || 0), 0))}}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-3">
        <div class="d-flex">
          <b-button v-if="status != 2" variant="primary" :disabled="!changes" @click="saveChanges">Save
            Changes</b-button>
          <b-button variant="secondary" class="ms-2" @click="$bvModal.hide('check-list-items');">Close</b-button>
        </div>

      </div>
    </b-modal>

    <b-modal id="approve" centered hide-header hide-footer>
      <div class="text-center">
        <div><i class="fs-1 text-info mdi mdi-check-circle"></i></div>
        <p>Are you sure you want to approve checkoff list for</p>
        <p><strong>{{ period }}</strong></p>
        <b-button :disabled="checkoff_list_loader" class="mx-1" variant="info" @click="confirmApprove">
          <b-spinner v-if="checkoff_list_loader" small></b-spinner>
          <span v-else>Yes, Approve</span>
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('approve')">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="delete" centered hide-header hide-footer>
      <div class="text-center">
        <div><i class="fs-1 text-danger mdi mdi-delete-circle"></i></div>
        <p>Are you sure you want to delete checkoff list</p>
        <p><strong>{{ period }}</strong></p>
        <b-button class="mx-1" variant="danger" @click="confirmDelete">Yes, Delete</b-button>
        <b-button variant="secondary" @click="$bvModal.hide('delete')">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="remove-item" centered hide-header hide-footer>
      <div class="text-center">
        <div><i class="fs-1 text-danger mdi mdi-delete-circle"></i></div>
        <p>Are you sure you want to delete record for</p>
        <p><strong>{{ member.name }}</strong></p>
        <b-button class="mx-1" variant="danger" @click="confirmItemDelete">Yes, Delete</b-button>
        <b-button variant="secondary" @click="$bvModal.hide('remove-item')">Cancel</b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { checkoffListComputed, checkoffListMethods, memberComputed, memberMethods } from "../../../state/helpers";

export default {
  page: {
    title: "View Past Checkoffs",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "View Past Checkoffs",
      items: [{ text: "Dashboard", to: "/", }, { text: "View Past Checkoffs", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'period', label: 'Period', visible: true },
        { key: 'created_at', label: 'Created On', visible: true },
        { key: 'addedby', label: 'Added By', visible: true },
        { key: 'status', label: 'Status', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      id: '',
      name: '',
      period: '',
      checkoff_list_loader: false,
      checkoff_list_items: [],
      name_hover: false,
      current_index: 0,
      item_index: 0, // tracks what row we are on so that we can show the input field
      cell_index: 0, // tracks what column we are on so that we can show the toolpin. 1-saving 2-loan 3-cofu 4-subscription
      member: '',
      new_member: '',
      show_member: false,
      status: '',
      paydate: new Date().toLocaleDateString('fr-CA'),

    };
  },
  computed: {
    ...checkoffListComputed,
    ...memberComputed,
    List() { return this.checkofflists.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.checkofflists.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.checkofflists.length > 0) { a = false; } else { a = true; } return a },
    changes() {
      return this.checkoff_list_items.some((item) => {  // tracks changes made to the checkoff list items to enable or disables the Save changes button
        if (item.changed) {
          return true
        }
        else {
          return false
        }
      })
    },
  },
  mounted() {
    this.fetchCheckoffLists();
    this.TotalRows = this.checkofflists.length;
    this.isBusy = false;
    this.fetchMembers();
  },
  methods: {
    ...checkoffListMethods,
    ...memberMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); },

    clearFields() {
      this.id = ''
      this.member = ''
      this.period = ''
      this.name = ''
      this.member = ''
      this.new_member = ''
      this.status = ''
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async edit(id, month, year, status) {
      this.id = id;
      this.name = `${month} - ${year}`;
      this.status = status;
      this.$bvModal.show('check-list-items');
      this.checkoff_list_loader = true;
      await axios.get(`/checkoff-list/${id}`).then((response) => {
        if (response.status == 200) {
          this.checkoff_list_items = response.data.checkoff_list_items;
          this.checkoff_list_loader = false;
        }
      });
    },

    approve(id, month, year) {
      this.id = id
      this.period = `${month} - ${year}`
      this.$bvModal.show('approve')
    },

    remove(id, member) {
      this.id = id
      this.member = member
      this.$bvModal.show('remove-item')
    },

    deleteModal(id, month, year) {
      this.id = id
      this.period = `${month} - ${year}`
      this.$bvModal.show('delete')
    },

    async confirmApprove() {
      const obj = {
        id: this.id
      }
      this.checkoff_list_loader = true;

      await axios.post('checkoff-approve', obj).then((response) => {
        if (response.status == 200) {
          this.fetchCheckoffLists();
          this.$toast.success('Checkoff List Approved')
          this.clearFields()
          this.checkoff_list_loader = false
          this.$bvModal.hide('approve')
        }
        else {
          this.$toast.error('Error Occured')
          this.checkoff_list_loader = false
        }
      })
    },

    async confirmDelete() {
      this.checkoff_list_loader = true
      const obj = {
        id: this.id
      }

      await axios.post('checkoff-delete', obj).then((response) => {
        if (response.status == 200) {
          this.fetchCheckoffLists();
          this.$toast.success('Checkoff List Deleted')
          this.clearFields()
          this.checkoff_list_loader = false
          this.$bvModal.hide('delete')
        }

        else {
          this.$toast.error('Error Occured')
          this.checkoff_list_loader = false
        }
      })
    },

    async confirmItemDelete() {
      const obj = {
        id: this.id,
      }

      await axios.post('/checkoff-list-item-delete', obj).then((response) => {
        if (response.status == 200) {
          this.checkoff_list_items = this.checkoff_list_items.filter(item => item.id !== this.id);
          this.clearFields()
          this.$bvModal.hide('remove-item')
          this.$toast.success('Record Deleted Successfully')
        }
      })
    },

    async saveChanges() {
      const obj = {
        id: this.id,
        items: this.checkoff_list_items
      }
      this.checkoff_list_loader = true;
      await axios.post('/checkoff-list-item-update', obj).then((response) => {
        if (response.status == 200) {
          this.checkoff_list_loader = false;
          this.$toast.success('Records Updated Successfully')
          this.checkoff_list_items = response.data.checkoff_list_items;
        }
        else {
          this.$toast.error('An error occurred while updating records')
          this.checkoff_list_loader = false;
        }
      })
    },

    async addNewItem() {
      this.show_member = false;
      const obj = {
        member_id: this.new_member,
        checkoff_list: this.checkoff_list_items[0].checkoff_list,
      }
      this.checkoff_list_loader = true;

      await axios.post('checkoff-list-item-add', obj).then((response) => {
        if (response.status == 200) {
          this.checkoff_list_items.unshift(response.data.item);
          this.new_member = '';
          this.checkoff_list_loader = false;
        }
        else {
          this.$toast.error('An error occurred while adding new item')
          this.checkoff_list_loader = false;
        }
      })
    }
  },
};
</script>